import request from '@/common/request'

class TipoICMSService {
  getAll() {
    return request.get('/tipo-icms')
  }

  create(data) {
    return request.post('/tipo-icms', data)
  }

  update(id, data) {
    return request.put(`/tipo-icms/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/tipo-icms/${id}`)
  }
}

export default new TipoICMSService()
